<!--融资申请-->
<template>
  <div :class="this.$route.query.yanse == 1 ? 'apply-loan-container2' :  'apply-loan-container'">
    <section class="apply-loan" ref="applyLoan">
      <div class="srot_grislge">
          <el-steps :active="this.$store.state[0].activeNum" align-center>
            <el-step title="步骤1" description=""></el-step>
            <el-step title="步骤2" description=""></el-step>
            <el-step title="步骤3" description=""></el-step>
            <el-step title="步骤4" description=""></el-step>
            <el-step title="步骤5" description=""></el-step>
          </el-steps>
        </div>
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive"  class="apply-loan__router-view" ref="applyLoanRouterView"></router-view>
      </keep-alive>
      <router-view v-if="!$route.meta.keepAlive"  class="apply-loan__router-view" ref="applyLoanRouterView"></router-view>
    </section>
  </div>
</template>

<script>
  export default {
    data () {
      return {
      };
    },
  };
</script>
<style lang="scss">
.srot_grislge{
  margin: 0 auto;
  margin-top: 20px;
  padding-left: 14%;
}
  .apply-loan-container {
    overflow: hidden;
    background: #f7e8c4;
  }
  .apply-loan-container2 {
    overflow: hidden;
    background: #c4f7cf;
  }

  .apply-loan {
    margin: 0 auto;
    width: $containerWidth;
  }

  .apply-loan__router-view {
    @include resetBFC;
    padding-top: 20px;
    padding-bottom: 20px;
    min-height: 550px;
  }
</style>



// WEBPACK FOOTER //
// ApplyLoan.vue?54333202